/** Split unusually tall rows at row boundaries instead of shrinking a whole table. */
export function prepareDetailPdfPages(element: HTMLElement, maxAspectRatio: number): { pages: HTMLElement[]; cleanup: () => void } {
  const originals = Array.from(element.children).filter((node): node is HTMLElement => node instanceof HTMLElement);
  const temporary: HTMLElement[] = [];
  const pages: HTMLElement[] = [];
  const cleanup = () => temporary.forEach(page => page.remove());
  try {
    for (const original of originals) {
      const maxHeight = original.getBoundingClientRect().width * maxAspectRatio;
      const sourceBody = original.querySelector('table')?.tBodies;
      const body = sourceBody?.[sourceBody.length - 1];
      const isPadding = (row: HTMLTableRowElement) => row.classList.contains('pdf-padding') ||
        row.cells.length === 1 && row.cells[0].colSpan === 23 && !row.textContent?.trim();
      if (!body || Array.from(body.rows).every(isPadding) || original.getBoundingClientRect().height <= maxHeight) { pages.push(original); continue; }
      const createPage = () => {
        const page = original.cloneNode(true) as HTMLElement;
        page.removeAttribute('id');
        page.classList.add('detail-pdf-render-page');
        page.querySelectorAll('.html2pdf__page-break').forEach(node => node.remove());
        const bodies = page.querySelector('table')!.tBodies;
        const target = bodies[bodies.length - 1];
        target.replaceChildren();
        element.appendChild(page);
        temporary.push(page);
        return { page, target };
      };
      let current = createPage();
      for (const row of Array.from(body.rows)) {
        // Padding should never add otherwise empty pages after an expanded table.
        if (isPadding(row)) continue;
        const copy = row.cloneNode(true) as HTMLTableRowElement;
        current.target.appendChild(copy);
        if (current.page.getBoundingClientRect().height > maxHeight && current.target.rows.length > 1) {
          copy.remove();
          pages.push(current.page);
          current = createPage();
          current.target.appendChild(copy);
        }
      }
      if (current.target.rows.length) pages.push(current.page);
    }
    return { pages, cleanup };
  } catch (error) { cleanup(); throw error; }
}
